<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isGoodsDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" />
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import request from '@/utils/request'

export default {
  name: 'Goods-edit',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    const that = this
    const Validatorintegral = (rule, value, callback) => {
      if (that.detailFormData.integral < 0) {
        return callback(new Error('商品积分不能为负数'))
      }
      if (that.detailFormData.integral > 99999) {
        return callback(new Error('商品积分不能大于99999'))
      }
      return callback()
    }
    const Validatorinventory = (rule, value, callback) => {
      if (that.detailFormData.inventory < 0) {
        return callback(new Error('商品库存不能为负数'))
      }
      if (that.detailFormData.inventory > 99999) {
        return callback(new Error('商品库存不能大于99999'))
      }
      return callback()
    }
    return {
      formCode: 'MODULES_GOODS',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/goods/goodsUpdate',
      formAddUrl: '/modules/goods/goodsAdd',
      detailFormButtons: {
        title: '新增商品',
        elements: [{ name: '提交', key: 'ADD', action: 'ADD', className: 'primary', hidden: this.componentType !== 'add' },
          { name: '提交', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        className: 'wt-section-long-content',
        elements: [
          { name: '商品编号',
            key: 'goodsNo',
            type: 'text',
            disabled: false,
            required: true,
            rules: [
              { min: 1, max: 20, message: '商品编号长度不能超过20', trigger: 'blur' }
            ] },
          { name: '商品标题',
            key: 'title',
            type: 'text',
            disabled: false,
            required: true,
            rules: [
              { min: 1, max: 50, message: '商品标题长度不能超过50', trigger: 'blur' }
            ] },
          { name: '商品副标题',
            key: 'subtitle',
            type: 'text',
            disabled: false,
            required: false,
            rules: [
              { min: 1, max: 100, message: '商品副标题长度不能超过100', trigger: 'blur' }
            ] },
          { name: '兑换方式',
            key: 'saleType',
            type: 'select',
            disabled: false,
            data: [
              { label: '自提', value: 1 },
              { label: '售货柜', value: 2 }
            ],
            required: true },
          { name: '商品积分',
            key: 'integral',
            type: 'text',
            disabled: false,
            required: true,
            rules: [
              { validator: Validatorintegral, trigger: 'blur' },
              { pattern: /^[+]{0,1}(\d+)$/, message: '请输入不小于0的整数', trigger: 'blur' }
            ] },
          { name: '商品类型', key: 'typeId', type: 'select', disabled: false, data: [], required: true },
          { name: '商品库存',
            key: 'inventory',
            type: 'text',
            disabled: false,
            required: true,
            rules: [
              { pattern: /^[+]{0,1}(\d+)$/, message: '请输入不小于0的整数', trigger: 'blur' },
              { validator: Validatorinventory, trigger: 'blur' }
            ] },
          { name: '商品图片(最多9张)', key: 'coverList', type: 'image', disabled: false, required: true, limit: 9, markText: '上传图片尺寸750x750px' },
          { name: '商品介绍', key: 'content', type: 'editor', disabled: false, required: false }]
      }
    }
  },
  created() {
    this.requestTypeList()
    if (this.componentType === 'add') {
      this.detailFormData.coverList = []
    }
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'ADD') {
        this.onAdd()
      } else if (item.action === 'EDIT') {
        this.onSave()
      }
    },
    onAdd() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestAddGoodsDetail()
      }).catch(() => {
      })
    },
    onSave() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdateGoodsDetail()
      }).catch(() => {
      })
    },
    /*  ------------------------- 网络请求  -------------------------  */
    requestAddGoodsDetail() {
      const that = this
      const sendData = JSON.parse(JSON.stringify(this.detailFormData))
      const _coverList = []
      for (const item of this.detailFormData.coverList) {
        _coverList.push(item.fileUrl)
      }
      sendData.cover = _coverList.join(',')
      this.$wtUtil.postFormData({
        url: this.formAddUrl,
        formData: sendData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'refresh')
        that.$emit('on-dialog-action', 'close')
      })
    },
    requestUpdateGoodsDetail() {
      const that = this
      const sendData = JSON.parse(JSON.stringify(this.detailFormData))
      const _coverList = []
      for (const item of this.detailFormData.coverList) {
        _coverList.push(item.fileUrl)
      }
      sendData.cover = _coverList.join(',')
      this.$wtUtil.postFormData({
        url: this.formUpdateUrl,
        formData: sendData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'refresh')
        this.$store.dispatch('setGarbageTypeDetailData', sendData)
        that.$emit('on-dialog-action', 'close')
      })
    },
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    },
    requestTypeList() {
      request({
        url: '/modules/goodsType/goodsTypeList',
        method: 'post'
      }).then(res => {
        if (res.code === '0') {
          for (const item of res.data) {
            item.label = item.name
            item.value = item.id
          }
          this.detailForm.elements[5].data = res.data
        }
      })
    }
  },
  computed: {
    ...mapState({
      isGoodsDetailLoading: state => state.goods.isGoodsDetailLoading,
      detailFormData: state => state.goods.goodsDetailData
    })
  },
  watch: {
    isGoodsDetailLoading(val) {
      if (!val) {
        if (this.componentType === 'edit') {
          if (this.detailFormData.cover && this.detailFormData.cover.length > 0) {
            const _coverList = this.detailFormData.cover.split(',')
            this.detailFormData.coverList = []
            for (const item of _coverList) {
              this.detailFormData.coverList.push({ fileUrl: item })
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
